import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Source Sans Pro', sans-serif;
 };


 .go2072408551{
  /* word-wrap: break-word; */
  word-break: break-all;
 };
`;

export default GlobalStyle;
